<div class="position-relative">
  <input
    class="input-base"
    [class]="{
      'input-large': inputSize() === InputSize.large,
      'input-small': inputSize() === InputSize.small,
      'input-icon-end-padding': showClearButton() || helpText(),
    }"
    [class.input-error]="error()"
    [attr.id]="controlId()"
    [value]="value()"
    [disabled]="disabled()"
    [placeholder]="placeholder()"
    [autocomplete]="autocomplete()"
    [type]="type()"
    [attr.inputMode]="inputMode()"
    (input)="handleInput($event)"/>
  @if (helpText()) {
    <mat-icon
      class="input-trailing-help-icon"
      [libTooltip]="helpText()"
      toolTipStyle="subtitle"
      [class]="{
        'input-trailing-icon-large': inputSize() === InputSize.large,
        'input-trailing-icon-small': inputSize() === InputSize.small,
      }"
      svgIcon="question">
    </mat-icon>
  }
  @if (showClearButton()) {
    <mat-icon
      class="input-trailing-icon"
      (click)="clearClicked()"
      [class]="{
        'input-trailing-icon-large': inputSize() === InputSize.large,
        'input-trailing-icon-small': inputSize() === InputSize.small,
      }"
      [svgIcon]="'close'">
    </mat-icon>
  }
</div>
